module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-blocks",
    class: {
      'cancelled': _vm.item.booking_item_state_id == 4
    }
  }, [_c('div', {
    staticClass: "date-price top-dates"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "id": "updateCalender"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "days-container",
    class: {
      'full-width': !_vm.isRestorable && !_vm.editable
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dateString)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "venue"
  }, [_vm._v(_vm._s(_vm.item.venue_name) + " (" + _vm._s(_vm.item.venue_town) + ")")]), _vm._v(" "), (_vm.isRestorable) ? _c('a', {
    staticClass: "fa",
    attrs: {
      "id": "restoreCourse"
    },
    on: {
      "click": function($event) {
        _vm.restore(_vm.item.id)
      }
    }
  }, [_c('div', {
    class: {
      'fa-history': !_vm.restoring, 'fa-refresh fa-spin': _vm.restoring
    }
  })]) : (_vm.editable) ? _c('a', {
    staticClass: "fa red",
    attrs: {
      "id": "removeCourse"
    },
    on: {
      "click": function($event) {
        _vm.remove(_vm.item.id)
      }
    }
  }, [_c('div', {
    class: {
      'fa-trash': !_vm.deleting, 'fa-spinner fa-pulse': _vm.deleting
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editable && !_vm.item.is_restorable) ? _c('router-link', {
    staticClass: "fa fa-pencil",
    attrs: {
      "to": {
        name: 'account.bookings.item.edit',
        params: {
          bookingId: _vm.bookingId,
          bookingItemId: _vm.item.id
        }
      },
      "id": "editBookingItem"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "course-details"
  }, [_c('span', {
    staticClass: "package"
  }, [_vm._v(_vm._s(_vm.item.package_name) + ": " + _vm._s(_vm.item.start_time) + "-" + _vm._s(_vm.item.end_time))])]), _vm._v(" "), _c('div', {
    staticClass: "course-overall",
    class: {
      'date-price': _vm.item.full_package_price == _vm.item.booking_item_total_cost || (!_vm.discounts.length && !_vm.fees.length)
    }
  }, [_c('b', {
    class: {
      'discount': _vm.item.full_package_price != _vm.item.booking_item_total_cost && (_vm.discounts.length || _vm.fees.length)
    }
  }, [_vm._v("\n                " + _vm._s(_vm.currencyFormat(parseFloat(_vm.item.full_package_price))) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-price"
  }, [_vm._l((_vm.fees), function(fee) {
    return (fee != undefined) ? _c('div', {
      staticClass: "discount-banner"
    }, [_c('span', [_vm._v(_vm._s(fee.description))]), _vm._v(" "), _c('b', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm.currencyFormat(Math.abs(fee.fee_amount))))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.discounts), function(discount) {
    return (discount != undefined && discount.discount_amount > 0) ? _c('div', {
      staticClass: "discount-banner"
    }, [_c('span', [_vm._v(_vm._s(discount.description))]), _vm._v(" "), _c('b', {
      staticClass: "amount"
    }, [_vm._v("- " + _vm._s(_vm.currencyFormat(Math.abs(discount.discount_amount))))])]) : _vm._e()
  }), _vm._v(" "), (_vm.item.full_package_price != _vm.item.booking_item_total_cost && (_vm.discounts.length || _vm.fees.length)) ? _c('div', {
    staticClass: "discount-banner"
  }, [_c('span', {
    staticClass: "final-cost"
  }, [_vm._v(" Price ")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.currencyFormat(_vm.item.booking_item_total_cost)))])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a1b86f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/Basket/BasketBookingItem.vue
// module id = 187
// module chunks = 0